import { Injectable } from '@angular/core';
import { IReturnNativeService } from './ireturn-native';

declare const returnNativeAndroid;

declare global {
    interface Window {
        webkit: any;
    }
}

@Injectable({ providedIn: 'root' })
export class ReturnNativeService implements IReturnNativeService {


    returnCommunicator(): void {
        /**
         * Send mensage for IOS or Android
         */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.returnNativeIOS) {
            this.comunicationIos();
        } else {
            this.comunicationAndroid();
        }
    }

    private comunicationIos() {
        window.webkit.messageHandlers.returnNativeIOS.postMessage({
            param: 'returnNative'
        });
    }

    private comunicationAndroid() {
        const param = 'returnNative';
        try {
            returnNativeAndroid.postMessage(param);
        } catch (error) {
        }
    }
}

